import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import type { TendencyZone } from '../../utils/responseTendency';
type FollicleClusterProps = {
  position: number;
  zone: TendencyZone;
};
const W = 260;
const H = 120;
const MAX = 24;
const GOLDEN = Math.PI * (3 - Math.sqrt(5));

/** Fixed slot layout (golden-angle spiral inside an ellipse) so follicles don't jump around. */
const SLOTS = Array.from({
  length: MAX
}, (_, i) => {
  const t = Math.sqrt((i + 0.5) / MAX);
  const a = i * GOLDEN;
  return {
    x: W / 2 + Math.cos(a) * t * 100,
    y: H / 2 + Math.sin(a) * t * 40
  };
});
export function FollicleCluster({
  position,
  zone
}: FollicleClusterProps) {
  const count = Math.round(3 + position * (MAX - 3));
  const r = 10.5 - position * 4.5;
  return <svg viewBox={`0 0 ${W} ${H}`} className="h-auto w-full" role="img" aria-label={`Illustrative follicle cluster: ${count} follicles shown`} data-id="element-578" data-mp="gdny65runj6h">
      <ellipse cx={W / 2} cy={H / 2} rx={124} ry={56} className="fill-wash stroke-ink/15" strokeWidth={1} data-id="element-579" data-mp="pbhu3flpcat4" />
      <AnimatePresence initial={false} data-id="element-580" data-mp="2vskg7p8ca3qt">
        {SLOTS.slice(0, count).map((s, i) => <motion.circle key={i} cx={s.x} cy={s.y} initial={{
        r: 0,
        opacity: 0
      }} animate={{
        r: r * (0.85 + i * 37 % 10 / 40),
        opacity: 1
      }} exit={{
        r: 0,
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className={zone === 'target' ? 'fill-white stroke-rx' : 'fill-white stroke-ink/70'} strokeWidth={1.4} data-id="element-581" data-mp="2qsy5pnjwb1lp" data-mpi={i} />)}
      </AnimatePresence>
    </svg>;
}